import { useCallback, useState } from "react";
import SessaoConfiguracao, { ConfiguracaoColunas } from "../../../../../components/BasicComponents/DisplayDados/SessaoConfiguracao";
import moment from "moment";
import DialogCriacaoEditPromocoes from "./DialogCriacaoEditPromocoes";
import { IDataPromocoes } from "../../../../../types/api/comercial/promocoes";
import truncarString from "../../../../../helpers/truncarString";

export default function Promocoes() {

  const [openModal, setOpenModal] = useState<TOpenModalPromocoes>(null)

  //funções manipuladoras
  const handleModalAction = useCallback((action: "open" | "close", id?: true | number, value?: IDataPromocoes | null) => {
    if (action === "close") setOpenModal(null)
    if (action === "open" && id && value) setOpenModal({ open: id, defaultValue: value })
    if (action === "open" && id && !value) setOpenModal({ open: id, defaultValue: null })
  }, [])
  //

  return (
    <>
      <SessaoConfiguracao<IDataPromocoes>
        titulo="Promoções"
        endpoints={{
          listar: "comercial/configuracoes/pesquisar-promocoes",
          deletar: "comercial/configuracoes/excluir-promocao",
        }}
        colunas={colunas}
        queryKey="pesquisar-promocoes"
        onEditar={(promocao) => {
          handleModalAction("open", promocao.id, promocao)
        }}
        onAdicionar={() => {
          handleModalAction("open", true,)
        }}
        mensagemSucessoDeletar="Promoção deletada com sucesso!"
        mensagemErroDeletar="Erro ao deletar promoção!"
      />
      {
        Boolean(openModal?.open) &&
        <DialogCriacaoEditPromocoes
          open={Boolean(openModal?.open)}
          handleClose={() => { handleModalAction("close") }}
          defaultValue={openModal?.defaultValue ? openModal : null}
        />
      }
    </>
  );
}

export type TOpenModalPromocoes = {
  open: number | boolean | null;
  defaultValue: IDataPromocoes | null;
} | null

const colunas: ConfiguracaoColunas<IDataPromocoes>[] = [
  {
    campo: "nome",
    titulo: "Nome",
  },
  {
    campo: "mensagem",
    titulo: "Mensagem",
    render: (value: string) => truncarString(value, 40),
  },
  {
    campo: "periodo_inicio",
    titulo: "Período Início",
    render: (value: string) => moment(value).format("DD/MM/YYYY"),
  },
  {
    campo: "periodo_fim",
    titulo: "Período Fim",
    render: (value: string) => moment(value).format("DD/MM/YYYY"),
  },
];
